import { render } from "./account-settings-navigation.vue?vue&type=template&id=689461a9&scoped=true&ts=true"
import script from "./account-settings-navigation.vue?vue&type=script&lang=ts"
export * from "./account-settings-navigation.vue?vue&type=script&lang=ts"

import "./account-settings-navigation.vue?vue&type=style&index=0&id=689461a9&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689461a9"]])

export default __exports__